module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/acknowledgments"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/timeline_of_modjeskas_lifecareer"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TIMELINE OF MODJESKA’S LIFE AND CAREER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_001"
    }
  }, [_vm._v("1"), _c('br'), _c('em', [_vm._v("Debut")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_002"
    }
  }, [_vm._v("2"), _c('br'), _c('em', [_vm._v("The Making of a Polish Actress")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('br'), _c('em', [_vm._v("Warsaw’s State of the Stars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('br'), _c('em', [_vm._v("A Colonial Party and the California Dream")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('br'), _c('em', [_vm._v("On the American Road")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('br'), _c('em', [_vm._v("The Roles of Madame Modjeska")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('br'), _c('em', [_vm._v("The Polish Modjeska")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('br'), _c('em', [_vm._v("Farewell Tour")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EPILOGUE: FINDING MODJESKA TODAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0